import fireBiRequest from './fireBiRequest';
import initAnalyticsBanners from './initAnalyticsBanners';
import initBiBanner from './initBiBanner';
import setLoginBtn from './setLoginBtn';
import initSocial from './initSocial';
import lazyloadImages from './lazyloadImages';
// import initComments from './comments/index';
import initApp from './initApp';
import loadKilkaya from './utils/kilkayaService';
// import initReadMore from './initReadMore';
import { CAMPAGIN_NAME, BANNER_IDS, BANNER_ID, CAMPAIGN_DETAILS, FEATURE_TYPE, } from '../consts';
// import initScrollArrow from './utils/initScrollArrow';

import initVideos from './utils/initVideos';

export default function init() {
  lazyloadImages();
  initSocial();
  initApp();
  // initReadMore();

  /*
   * Your init code here
  */
  initVideos();
  // initScrollArrow([scrollTo ID])
  // initComments();
  if (CAMPAGIN_NAME !== '') {
    initAnalyticsBanners({
      campaignName: CAMPAGIN_NAME,
      bannerIds: BANNER_IDS,
    });
    initBiBanner({
      bannerId: BANNER_ID,
      campaignName: CAMPAGIN_NAME,
      campaignDetails: CAMPAIGN_DETAILS,
      featureType: FEATURE_TYPE,
    });

    setLoginBtn('loginLink');
  }

  // Fire GA pageview
  if (typeof ga === 'function') {
    // eslint-disable-next-line no-undef
    ga('send', 'pageview');
  }
  fireBiRequest();
  // Fire Kilkaya
  loadKilkaya();
}
